
import React from 'react';
import { Button } from '@/components/ui/button';
import { ChefHat, RefreshCw, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

interface MenuErrorProps {
  message: string;
}

const MenuError: React.FC<MenuErrorProps> = ({ message }) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background to-accent/5">
      <div className="text-center max-w-md mx-auto px-6">
        {/* French restaurant style icon */}
        <div className="flex justify-center mb-8">
          <ChefHat className="h-16 w-16 text-primary/70" />
        </div>
        
        <h1 className="text-3xl font-bold text-foreground mb-4">
          Oups ! Un petit souci en cuisine
        </h1>
        
        <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
          Il semblerait que ce menu ne soit plus disponible ou qu'il y ait eu un petit problème technique. 👨‍🍳
        </p>
        
        <div className="space-y-4">
          <Button onClick={handleRefresh} size="lg" className="w-full">
            <RefreshCw className="mr-2 h-5 w-5" />
            Rafraîchir la page
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full">
            <Link to="/">
              <Home className="mr-2 h-5 w-5" />
              Retour à l'accueil
            </Link>
          </Button>
        </div>
        
        <p className="text-sm text-muted-foreground/60 mt-8">
          Le problème persiste ? Contactez notre équipe support
        </p>
        
        {/* Technical details for debugging, hidden by default */}
        <details className="mt-6 text-left">
          <summary className="text-xs text-muted-foreground/40 cursor-pointer hover:text-muted-foreground/60">
            Détails techniques
          </summary>
          <p className="text-xs text-muted-foreground/40 mt-2 font-mono bg-muted/20 p-2 rounded">
            {message}
          </p>
        </details>
      </div>
    </div>
  );
};

export default MenuError;
